import React from 'react';
import ReactECharts from 'echarts-for-react';

export interface IChartBarProps {
    title?: string;
    subTitle?: string;
    chartType?: 'bar' | 'line';
    legend?: string[];
    dates?: string[];
    dataSeries?: number[][];
    color?: string[];
    trendSeriesIndex?: number;
    trendSeriesName?: string;
}

export const ChartLineBar: React.FC<IChartBarProps> = ({
    title = 'Title',
    subTitle = 'Sub title',
    chartType = 'bar',
    legend = ['item 1'],
    dates = ['0'],
    dataSeries = [[120]],
    color = ['#03a9f4', '#4caf50', '#f44336', '#ffeb3b'],
    trendSeriesIndex,
    trendSeriesName
}) => {

    const series = dataSeries.map((seriesData, index) => ({
        name: legend[index],
        type: chartType,
        data: seriesData,
        itemStyle: {
            color: color[index] || '#999', // Usando as cores fornecidas com um fallback padrão
        },
        lineStyle: {
            width: 2,
            type: 'line',
        },
        symbol: 'none',
    }));

    if (trendSeriesIndex !== undefined && trendSeriesName) {
        // const validIndex = trendSeriesIndex >= 0 && trendSeriesIndex < dataSeries.length ? trendSeriesIndex : 0;
        const trendData = calculateLinearTrend(dataSeries[trendSeriesIndex], dates);
        series.push({
            name: trendSeriesName,
            type: 'line',
            data: trendData,
            itemStyle: {
                color: '#ff0000',
            },
            lineStyle: {
                width: 2,
                type: 'dashed',
            },
            symbol: 'none',
        });
    }
    const options = {
        title: {
            text: title,
            subtext: subTitle,
        },
        tooltip: {
            trigger: 'axis',
        },
        toolbox: {
            feature: {
                saveAsImage: { show: true },
            },
        },
        legend: {
            data: legend,
        },
        grid: {
            left: '1.3%',
            right: '1%',
            bottom: '1%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: chartType === 'bar',
            data: dates,
            axisLabel: {
                rotate: 45,
                interval: 0,
            }
        },
        yAxis: {
            type: 'value',
        },
        series,
    };

    return <ReactECharts option={options} />;
};

function calculateLinearTrend(seriesData: number[], dates: string[]) {
    const xValues = seriesData.map((_, index) => index);
    const yValues = seriesData;
    const n = xValues.length;
    const sumX = xValues.reduce((acc, val) => acc + val, 0);
    const sumY = yValues.reduce((acc, val) => acc + val, 0);
    const sumXY = xValues.reduce((acc, val, i) => acc + (val * yValues[i]), 0);
    const sumXX = xValues.reduce((acc, val) => acc + (val * val), 0);

    const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX ** 2);
    const intercept = (sumY - slope * sumX) / n;

    return xValues.map(x => slope * x + intercept);
}
